<!-- 绘画列表页 -->
<template>
  <div class="component-header">
    <!-- 列表页开始 -->
    <div v-if="datalist.length > 0">
      <div class="article" v-for="(item, index) in datalist" :key="index">
        <div class="articletop">
          <div class="articletopleft def-hover-trs">
            <a target="_blank" :href="item.links">{{ item.title }}</a>
          </div>
          <div class="articletopright">
            <!-- 当前票数：
            <span>{{ numberFormat(item.VoteNum) }}</span> -->
          </div>
        </div>
        <!-- <div class="middle">
          作者：
          <span>{{ item.Author }} /{{ item.Province }}</span>
        </div> -->
        <p style="line-height: 2em">
          {{ item.Intro }}
        </p>
        <div class="di">
          <a target="_blank" :href="item.links"><span>查看更多</span>>></a>
          <!-- <a href="./detail.html"><span>查看更多</span>>></a> -->
        </div>
      </div>
      <!-- 列表页结束 -->
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import VideoDialog from "../components/video-dialog.vue"; // 视频弹窗
import { getVideoposter } from "@/utils/getVideoposter";
import QRCode from "qrcodejs2"; // 引入qrcode
export default {
  name: "ComponentHeader",
  components: {
    VideoDialog
  },
  props: ["datalist"],
  data() {
    return {
      tankuang: false,
      isphone: false
    };
  },
  computed: {
    ...mapState([
      "userinfo", // 用户信息
      "headerNavIndex", // 当前激活的导航菜单的下标
      "leftNavIndex" //四个类型的作品类型下标
    ])
  },
  mounted() {
    if (this.isMobile()) {
      this.isphone = true;
    } else {
      this.isphone = false;
    }
  },
  methods: {
    isMobile() {
      // alert(navigator.userAgent);
      let flag = navigator.userAgent.match(
        /(Android|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    open(url) {
      if (this.isMobile()) {
        window.open(url);
      } else {
        this.stop();
        $("#qrcode").html("");
        this.qrcode(url);
        this.tankuang = true;
      }
    },
    closetankuang() {
      this.tankuang = false;
      this.move();
    },
    qrcode(url) {
      let qrcode = new QRCode("qrcode", {
        width: 180,
        height: 180,
        text: url // 二维码地址
      });
      console.log("qrcode：", qrcode);
    },
    //禁止滚动
    stop() {
      var mo = function(e) {
        e.preventDefault();
      };
      document.body.style.overflow = "hidden";
      document.addEventListener("touchmove", mo, false); //禁止页面滑动
    },
    /***取消滑动限制***/
    move() {
      var mo = function(e) {
        e.preventDefault();
      };
      document.body.style.overflow = ""; //出现滚动条
      document.removeEventListener("touchmove", mo, false);
    }
  }
};
</script>

<!-- 组件独有样式 -->
<style scoped>
/* 弹框 */
.ptankuang {
  position: fixed;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
.ctankuang {
  background-color: rgb(255, 255, 255);
  width: 500px;
  height: 430px;
  margin: 0 auto;
  position: absoulte;
  top: 50%;
  left: 50%;
  margin-top: 15%;
}
/* 提示大标题 */
.tishititle {
  position: relative;
  top: 30px;
  font-size: 20px;
}
/* 二维码提示文字 */
.tishiwenzi {
  font-size: 16px;
  margin-bottom: 5px;
}
/* 二维码图片 */
#qrcode {
  /* padding-left: 150px;
  padding-top: 50px; */
  width: 100%;
  height: 200px;
  position: relative;
  top: 50px;
  text-align: center;
}
/* 关闭二维码弹框 */
.btnssss {
  width: 100%;
  position: relative;
  /* top: 50px; */
  text-align: center;
  /* margin-top: 20px; */
  bottom: -100px;
}
.tiaozhuan {
  margin-top: 23px;
}
.my-btn {
  float: left;
  padding: 10px 20px;
  margin-top: 22px;
}
.component-header {
  position: relative;
  min-width: 1200px;
}
.titlehang1 {
  width: 100%;
  overflow: hidden; /*超出部分隐藏*/
  white-space: nowrap; /*不换行*/
  text-overflow: ellipsis; /*超出部分文字以...显示*/
}
.active {
  background-color: var(--main-color);
  color: #fff;
}
.banner {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
  padding-bottom: 100px;
}
/* 列表页开始 */

.article {
  width: 100%;
  border-bottom: #f9dfd0 solid 2px;
  overflow: hidden;
}

.articletop {
  width: 100%;
  margin-top: 48px;
  display: flex;
  justify-content: space-between;
}

.articletopleft {
  width: 800px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 36px;
  line-height: 36px;
  font-size: 32px;
  margin-bottom: 20px;
}
.articletopleft a {
  color: #000;
}
.articletopright > span {
  color: #a51400;
}

.articletopright {
  font-size: 22px;
}

.middle {
  height: 18px;
  line-height: 18px;
  font-size: 18px;
}

.middleright {
  width: 228px;
  height: 45px;
  align-items: center;
  float: right;
  border-radius: 3px;
  background-color: var(--main-color);
  color: #fff;
  text-align: center;
}
.middlerightpc {
  font-size: 28px;
  line-height: 45px;
}
.middlerightmobile {
  font-size: 28px;
  line-height: 55px;
}
.middleright a {
  color: #fff;
}

.article > p {
  font-size: 16px;
  line-height: 1.5em;
  margin-top: 36px;
  text-indent: 32px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}

.di {
  font-size: 16px;
  line-height: 1.5em;
  width: auto;
  height: 48px;
  float: right;
}

.di span {
  font-size: 10px;
  color: #000;
}

.di a {
  color: #a51400;
}

.di:hover {
  color: #a51400;
}

/* 列表页结束 */
</style>



// WEBPACK FOOTER //
// src/components/wzlist.vue